import React, { ReactNode } from "react";
import Firebase from "./Firebase"

const FirebaseContext = React.createContext<Firebase|null>(null);

const FirebaseProvider = ({ children }: { children: ReactNode}) => {
  return (
    <FirebaseContext.Provider value={new Firebase()}>{children}</FirebaseContext.Provider>
  );
};

export { FirebaseProvider, FirebaseContext }
